<template>
  <div class="chart flex-column flex-justify-start flex-align-start" :class="[{'card-gap': gap}]">
    <div class="chart-head flex-row flex-justify-start flex-align-start">水量</div>
    <div class="chart-contain flex-row flex-justify-center flex-align-start">
      <div id="waterref" class="chart-area"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'WaterChart',
  props: {
    gap: {
      type: Boolean,
      default: true
    },
    water: {
      type: Object,
      default: () => ({
        thiswater: [],
        lastwater: []
      })
    }
  },
  data() {
    return {
      waterChart: null
    }
  },
  watch: {
    water: {
      handler() {
        this.$nextTick(() => {
          this.initChart()
        })
      },
      deep: true
    },
  },
  beforeDestroy() {
    if(this.waterChart != null) {
      this.waterChart.dispose()
      this.waterChart = null
    }
  },
  methods: {
    initChart() {
      var chartDom = document.getElementById('waterref')
      if(!chartDom) {
        return
      }
      if (!this.waterChart) {
        this.waterChart = echarts.init(chartDom);
      }
      var option = {
        tooltip: {
          trigger: 'axis',
          extraCssText: 'text-align: left;',
          axisPointer: {
            type: 'none'
          }
        },
        legend: {
          data: ['今年水量', '去年水量']
        },
        xAxis: [
          {
            type: 'category',
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '水量 / 吨',
            // min: 0,
            // max: 100000,
            // interval: 20000,
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        series: [
          {
            name: '今年水量',
            type: 'line',
            tooltip: {
              valueFormatter: function (value) {
                return value + ' 吨';
              }
            },
            itemStyle: {
              color: '#08affe'
            },
            data: this.water.thiswater
          },
          {
            name: '去年水量',
            type: 'line',
            tooltip: {
              valueFormatter: function (value) {
                return value + ' 吨';
              }
            },
            itemStyle: {
              color: '#6bc26b'
            },
            data: this.water.lastwater
          }
        ]
      }
      this.waterChart.setOption(option)
    }
  }
}
</script>

<style scoped>
.chart {
  width: 49.5%;
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
}
.card-gap {
  margin-right: 1%;
}
.chart-head {
  font-family: 'Arial';
  font-size: 18px;
  margin-left: 20px;
  margin-top: 10px;
}
.chart-area {
  min-width: 800px;
  min-height: 400px;
}
.chart-contain {
  width: 100%;
  overflow: hidden;
}
</style>
